import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { UsuarioService } from './usuario.service';

@Injectable({
  providedIn: 'root',
})
export class IaService extends ApiConfig {
  constructor(private http: HttpClient, private usuarioService: UsuarioService) {
    super();
  }

  chat(texto: string) {
    return this.http.post(this.URL_API + 'ia/chat', { Texto: texto, IdUsuario: this.usuarioService.get().Id });
    // return this.http.post(this.URL_API + 'ia/chat', { Texto: texto });
  }
}
